import React, { useEffect } from 'react'
import { useSelector } from 'react-redux';
import { companyProfileInfoForUser } from '../../../../API/Settings/Company Settings/companySettingsAPI';

const PosSalesDetailsPrint = (props) => {
    const { branch } = props;
    const companyProfileData = useSelector(
        (state) => state?.companyProfileSlice?.userValue
    );
    const salesDetails = useSelector(
        (state) => state.posReportshiftSlice.salesReport);
    const decimalPosition = localStorage.getItem("decimalPosition");

    // Define all styles as objects
    const styles = {
        printMainDiv: {
            backgroundColor: "white",
            padding: "5mm", // Reduced padding
            margin: 0,
            '@media print': {
                pageBreakAfter: 'avoid',
                pageBreakInside: 'avoid'
            }
        },
        headerDiv: {
            display: "flex",
            justifyContent: "space-between",
            padding: "0",
            marginBottom: "5px",
            alignItems: "flex-start", // Changed to flex-start
            '@media print': {
                pageBreakAfter: 'avoid'
            }
        },
        centerText: {
            textAlign: "center",
            flex: 1
        },
        rightText: {
            textAlign: "right",
            flex: 1 
        },
        logoContainer: {
            flex: 1 
        },
        mediumText: {
            fontSize: "14px", 
            margin: "0 0 3px 0" 
        },
        smallText: {
            fontSize: "11px", 
            margin: "0 0 2px 0" 
        },
        smallerText: {
            fontSize: "9px", 
            margin: "0 0 1px 0" 
        },
        tableContainer: {
            paddingTop: "3px", 
            margin: 0
        },
        sectionHeader: {
            width: "100%",
            padding: "5px 0 5px 10px", 
            backgroundColor: "#f9f0f0",
            margin: "0 0 3px 0", 
            fontSize: "12px", 
            '@media print': {
                pageBreakAfter: 'avoid'
            }
        },
        categoryContainer: {
            pageBreakInside: 'avoid',
            marginBottom: '10px',
            '@media print': {
                pageBreakAfter: 'auto',
                pageBreakInside: 'avoid'
            }
        },
        categoryHeader: {
            color: "#4343fd",
            fontWeight: "bold",
            padding: "4px 0 4px 10px", // Reduced padding
            margin: 0,
            fontSize: "12px", // Added font size
            backgroundColor: "#f0f0f0", // Added background
            '@media print': {
                pageBreakAfter: 'avoid'
            }
        },
        table: {
            width: '100%',
            borderCollapse: 'collapse',
            fontSize: "11px", // Added font size
            '@media print': {
                pageBreakInside: 'avoid'
            }
        },
        tableRow: (index) => ({
            backgroundColor: index % 2 === 0 ? "white" : "rgb(214 212 212)",
            height: "auto", // Changed from fixed 29px
            minHeight: "24px", // Added minimum height
            '@media print': {
                pageBreakInside: 'avoid'
            }
        }),
        tableCell: {
            border: "none",
            padding: "3px 5px" // Added padding
        },
        tableFooter: {
            backgroundColor: "#e9e7e7",
            '@media print': {
                pageBreakInside: 'avoid'
            }
        },
        grandTotal: {
            backgroundColor: "#b6b6b6",
            display: "flex",
            width: "100%",
            padding: "5px 0", // Added padding
            marginTop: "5px", // Added margin
            fontSize: "12px", // Added font size
            '@media print': {
                pageBreakBefore: 'avoid'
            }
        },
        paymentDetails: {
            paddingTop: '15px', // Reduced from 20px
            '@media print': {
                pageBreakInside: 'avoid'
            }
        }
    };

    useEffect(() => {
        companyProfileInfoForUser();
    }, []);

    return (
        <div style={styles.printMainDiv}>
            {/* Compact Header Section */}
            <div style={styles.headerDiv}>
                <div style={styles.logoContainer}>
                    <img src={companyProfileData?.companyLogo} alt="" style={{ height: "40px" }} /> {/* Reduced height */}
                </div>
                <div style={styles.centerText}>
                    <h1 style={styles.mediumText}>Sales Details</h1>
                    <p style={styles.smallText}>{branch?.branchName}</p>
                </div>
                <div style={styles.rightText}>
                    <p style={styles.smallerText}>{companyProfileData?.companyName}</p>
                    <p style={styles.smallerText}>{companyProfileData?.companyAddress}</p>
                    <p style={styles.smallerText}>{companyProfileData?.companyContact}</p>
                </div>
            </div>

            <div style={styles.tableContainer}>
                <div style={styles.sectionHeader}>
                    <p style={{ margin: 0 }}>Product Details</p>
                </div>

                {salesDetails?.productDetails?.list?.map((item, index) => (
                    // <React.Fragment key={index}>
                    <div
                        key={index}
                        style={{
                            pageBreakInside: 'avoid',
                            marginBottom: '10px',
                        }}
                    >
                        <div style={styles.categoryHeader}>{item?.categoryName}</div>
                        <div style={styles.categoryContainer}>
                            <table style={styles.table}>
                                {index === 0 && (
                                    <thead>
                                        <tr>
                                            <th style={{ ...styles.tableCell, textAlign: 'left' }}>Product</th>
                                            <th style={{ ...styles.tableCell, textAlign: 'center' }}>Qty</th>
                                            <th style={{ ...styles.tableCell, textAlign: 'center' }}>Amount</th>
                                        </tr>
                                    </thead>
                                )}
                                <tbody>
                                    {item?.list?.map((item, i) => (
                                        <tr key={i} style={styles.tableRow(i)}>
                                            <td style={{ ...styles.tableCell, width: "50%" }}>{item.productName}</td>
                                            <td style={{ ...styles.tableCell, width: "25%", textAlign: "center" }}>{item.qty}</td>
                                            <td style={{ ...styles.tableCell, width: "25%", textAlign: "center" }}>{item.amount}</td>
                                        </tr>
                                    ))}
                                </tbody>
                                <tfoot>
                                    <tr style={styles.tableFooter}>
                                        <td style={styles.tableCell}>&nbsp;</td>
                                        <td style={{ ...styles.tableCell, textAlign: "center" }}>
                                            {item?.list?.reduce((acc, current) => acc + Number(current?.qty || 0), 0)?.toFixed(decimalPosition)}
                                        </td>
                                        <td style={{ ...styles.tableCell, textAlign: "center" }}>
                                            {item?.list?.reduce((acc, current) => acc + Number(current?.amount || 0), 0)?.toFixed(decimalPosition)}
                                        </td>
                                    </tr>
                                </tfoot>
                            </table>
                        </div>
                        {/* </React.Fragment> */}
                    </div>
                ))}

                <div style={styles.grandTotal}>
                    <p style={{ textAlign: "center", width: "50%" }}>Grand Total</p>
                    <p style={{ textAlign: "center", width: "25%" }}>{salesDetails?.productDetails?.qtyTotal}</p>
                    <p style={{ textAlign: "center", width: "25%" }}>{salesDetails?.productDetails?.amountTotal}</p>
                </div>

                <div style={styles.paymentDetails}>
                    <div style={styles.sectionHeader}>
                        <p style={{ margin: 0 }}>Payment Details</p>
                    </div>
                    <table style={styles.table}>
                        <thead>
                            <tr>
                                <th style={{ ...styles.tableCell, textAlign: 'left' }}>Payment Method</th>
                                <th style={{ ...styles.tableCell, textAlign: 'center' }}>Amount</th>
                            </tr>
                        </thead>
                        <tbody>
                            {salesDetails?.paymentSummary?.list?.map((item, i) => (
                                <tr key={i} style={styles.tableRow(i)}>
                                    <td style={styles.tableCell}>{item._id}</td>
                                    <td style={{ ...styles.tableCell, textAlign: "center" }}>{item.amount}</td>
                                </tr>
                            ))}
                        </tbody>
                        <tfoot>
                            <tr style={styles.tableFooter}>
                                <td style={{ ...styles.tableCell, textAlign: "center" }}>&nbsp;</td>
                                <td style={{ ...styles.tableCell, textAlign: "center" }}>
                                    {parseFloat(salesDetails?.paymentSummary?.total)?.toFixed(decimalPosition)}
                                </td>
                            </tr>
                        </tfoot>
                    </table>
                </div>
            </div>
        </div>
    )
}

export default PosSalesDetailsPrint